import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from "react-bootstrap/Modal";
import { InfoHover } from "../InfoHover/InfoHover";
import { Accordion, Table } from "react-bootstrap";
import axios from "axios";
import { useAuth0 } from '@auth0/auth0-react';


export const TradingZoneModal = ({
    isNewTradingZone,
    showModal,
    setShowModal,
    handleTradingZone,
    existingTradingZone,
    tradeConfig,
    connections,
    userId,
}) => {
    const blankTradingZone = {
        min: 0,
        max: 0,
        validThrough: 12,
    };
    const [tradingZone, setTradingZone] = useState(isNewTradingZone ? blankTradingZone : existingTradingZone);
    const [groupList, setGroupList] = useState([]);
    const [automatedTradingZones, setAutomatedTradingZones] = useState([]);
    const { getAccessTokenSilently } = useAuth0();

    const getAutomatedTradingZones = async (ticker) => {
        let automatedZones = [];
        const token = await getAccessTokenSilently();
        const headers = {
            'Authorization': `Bearer ${token}`,
        };
        const params = {
            uid: userId,
            ticker: ticker,
        };
        try {
            const zones = await axios.get(
                `${process.env.REACT_APP_API_URL}/algo/zones`,
                {
                    headers: headers,
                    params: params
                }
            );
            if (zones && zones.data) {
                automatedZones = zones.data;
                setAutomatedTradingZones(automatedZones);
            } else {
                setAutomatedTradingZones([]);
            }
        } catch (error) {
            console.log('Could not get automated zones', error)
        }
    }


    useEffect(() => {
        const groups = [];
        if (tradeConfig && connections && groups.length === 0) {
            for (const buid in connections) {
                if (tradeConfig[buid] && tradeConfig[buid].accountGroups.length) {
                    for (const group of tradeConfig[buid].accountGroups) {
                        let isCopiedToGroup = false;
                        if (
                            group.tradingZones &&
                            group.tradingZones.length &&
                            group.tradingZones.filter((zone) =>
                                zone.id === tradingZone.id
                            ).length
                        ) {
                            isCopiedToGroup = true;
                        }
                        groups.push({
                            connection: connections[buid].name,
                            groupName: group.groupName,
                            buid: buid,
                            isCopiedToGroup: isCopiedToGroup,
                        });
                    }
                }
            }
        }
        setGroupList(groups);
        if (!isNewTradingZone) {
            getAutomatedTradingZones(existingTradingZone.ticker);
        }
    }, []);

    const handleTradingZoneChange = (e) => {
        setTradingZone({
            ...tradingZone,
            [e.target.name]: e.target.value
        });
    };

    const handleAutomatedZoneChange = (e) => {
        const chosenZone = automatedTradingZones.find((zone) => zone.displayText === e.target.value);
        setTradingZone({
            id: tradingZone.id,
            createdDate: tradingZone.createdDate,
            min: chosenZone.min,
            max: chosenZone.max,
            ticker: tradingZone.ticker,
            type: chosenZone.type,
            zoneType: chosenZone.zoneType,
            displayText: chosenZone.displayText,
            validThrough: tradingZone.validThrough,
        });
    };

    const handleTradingZoneTickerChange = (e) => {
        setTradingZone({
            ...tradingZone,
            [e.target.name]: e.target.value
        });
        getAutomatedTradingZones(e.target.value)
    };

    const handleCopyZone = (e, buid, groupName) => {
        const groups = JSON.parse(JSON.stringify(groupList));
        if (groups.length) {
            const index = groups.findIndex((g) => g.buid === buid && g.groupName === groupName);
            if (index >= 0) {
                groups[index].isCopiedToGroup = e.target.checked;
            }
        }
        setGroupList(groups);
    }

    const handleClose = () => setShowModal(false);

    const GroupList = ({ groups }) => {
        if (groups.length) {
            return (
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Connection</th>
                            <th>Group</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            groups
                                .map((group) => {
                                    return (
                                        <tr key={group.connection + group.groupName}>
                                            <td>{group.connection}</td>
                                            <td>
                                                <Form.Check
                                                    type="switch"
                                                    id={group.connection + group.groupName}
                                                    name={group.groupName}
                                                    label={group.groupName}
                                                    checked={group.isCopiedToGroup}
                                                    onChange={(e) => handleCopyZone(e, group.buid, group.groupName)}
                                                    value={group.isCopiedToGroup}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })
                        }
                    </tbody>
                </Table>
            )
        }

    };

    return (
        <Modal
            root={document.body}
            size="lg"
            show={showModal}
            onHide={handleClose}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {InfoHover(
                        isNewTradingZone ? 'Add a Supply or Demand Zone' : 'Edit a Supply or Demand Zone',
                        "You can set custom trading zones to control the price ranges that the strategies you subscribe to will execute trades. If any custom trading zones are set, it will override any automated trading zones."
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="pb-3">
                    <Form.Group className="mb-3" controlId="tradingZones">
                        <Form.Label className="pt-2">
                            <strong>Ticker</strong>
                        </Form.Label>
                        <Form.Select
                            onChange={handleTradingZoneTickerChange}
                            value={tradingZone?.ticker}
                            name="ticker"
                        >
                            <option>Select ticker</option>
                            <option key="ES" value="ES">ES</option>
                            <option key="MES" value="MES">MES</option>
                            {/* <option key="NQ" value="NQ">NQ</option> */}
                            <option key="MNQ" value="MNQ">MNQ</option>
                            <option key="GC" value="GC">GC</option>
                            <option key="MGC" value="MGC">MGC</option>
                            {/* <option key="YM" value="YM">YM</option>
                            <option key="CL" value="CL">CL</option> */}
                        </Form.Select>
                        {
                            (automatedTradingZones.length > 0 || tradingZone?.displayText?.length > 0) &&
                            <>
                                <Form.Label className="pt-2">
                                    <strong>{InfoHover(
                                        "Common Zones",
                                        "You can optionally choose from a list of common supply and demand zones to populate the zone values for you. You can still change the values even if you select a common zone."
                                    )}</strong>
                                </Form.Label>
                                <Form.Select
                                    onChange={handleAutomatedZoneChange}
                                    value={tradingZone?.displayText}
                                    name="automatedZone"
                                >
                                    <option>Select common zone</option>
                                    {automatedTradingZones.map((zone) => (
                                        <option
                                            key={zone.time + zone.type + zone.zoneType}
                                            value={zone.displayText}
                                        >{zone.displayText}</option>
                                    ))}
                                </Form.Select>
                            </>
                        }
                        <Form.Label className="pt-2">
                            <strong>{InfoHover(
                                "Zone Type",
                                "Choose supply for bearish trading zones and demand for bullish trading zones."
                            )}</strong>
                        </Form.Label>
                        <Form.Check
                            type="radio"
                            label="Supply"
                            key="supply"
                            name="type"
                            onChange={handleTradingZoneChange}
                            value="supply"
                            checked={tradingZone?.type === 'supply'}
                        />
                        <Form.Check
                            type="radio"
                            label="Demand"
                            key="demand"
                            name="type"
                            onChange={handleTradingZoneChange}
                            value="demand"
                            checked={tradingZone?.type === 'demand'}
                        />
                        <Form.Label className="pt-2">
                            <strong>Minimum Price</strong>
                        </Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Minimum Zone Price"
                            value={tradingZone?.min}
                            name="min"
                            onChange={handleTradingZoneChange}
                            required
                        />
                        <Form.Label className="pt-2">
                            <strong>Maximum Price</strong>
                        </Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Maximum Zone Price"
                            value={tradingZone?.max}
                            name="max"
                            onChange={handleTradingZoneChange}
                            required
                        />
                        <Form.Label className="pt-2">
                            <strong>Zone Expiration (Hours)</strong> - Expires at {
                                existingTradingZone &&
                                    existingTradingZone.createdDate ?
                                    new Date(new Date(existingTradingZone.createdDate).getTime() + tradingZone.validThrough * 60 * 60 * 1000).toLocaleString('en-US') :
                                    new Date(new Date().getTime() + tradingZone.validThrough * 60 * 60 * 1000).toLocaleString('en-US')
                            }
                        </Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Number of hours the zone is valid for."
                            value={tradingZone?.validThrough}
                            name="validThrough"
                            onChange={handleTradingZoneChange}
                            required
                        />
                    </Form.Group>
                    <div className="border-bottom mb-3 pb-3">
                        <Form.Label className="pt-2">
                            <strong>{InfoHover(
                                "Apply Zone to Groups",
                                "Toggle on the groups you want to copy the zone to."
                            )}
                            </strong>
                        </Form.Label>
                        <GroupList
                            groups={groupList}
                        />
                    </div>

                    <div className="d-flex justify-content-center">
                        <Button
                            variant="primary"
                            onClick={() => handleTradingZone(tradingZone, groupList)}>
                            {isNewTradingZone ? 'Add Trading Zone' : 'Edit Trading Zone'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}